// apiaxios.js
// autor: WdePaula
// data: 12/9/24 | 18h44
// objetivo: fazer get, put, post e delete no servidor
// data: 19/10/24 | 20h57 | remoção de código redundante e delegando tudo para "apiHandlerError.js"



// apiaxios.js
import Axios from "axios";
import { encryptPass } from "./cryptosenha";
import handleApiError from './apiErrorHandler'; // Importa o handler de erro
// import Swal from 'sweetalert2';

const API_URL = process.env.REACT_APP_API_URL;
const BA_USERNAME = process.env.REACT_APP_BA_USERNAME;
// const BA_PASSWORD = encryptPass(process.env.REACT_APP_BA_PASSWORD);

const apiaxios = Axios.create({
    baseURL: API_URL,
    // auth: { username: BA_USERNAME, password: BA_PASSWORD },
    auth: { username: BA_USERNAME, password: encryptPass(process.env.REACT_APP_BA_PASSWORD) },
    timeout: 30000, // Timeout de 30 segundos
    headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*'
    }
});

// Interceptor de respostas para tratamento de erros
apiaxios.interceptors.response.use(
    response => response,
    error => {
        const { config } = error;
        // Verifica se 'skipErrorHandler' foi passado como true na requisição
        if (config && config.skipErrorHandler) {
            return Promise.reject(error); // Ignora o handleApiError
        }

        // Caso contrário, chama o handler de erro global
        handleApiError(error);
        
        // Retorna a rejeição para ser tratada localmente, se necessário
        return Promise.reject(error);
    }
);

export default apiaxios;